module.exports = __webpack_public_path__ + "static/media/ico_open.698ab786.svg";